import { RawRuleOf } from '@casl/ability';

import { SubjectAbilitiesDto } from '../dtos/subject-abilities.dto';
import { AppSubjectEnum } from '../enums/app-subject.enum';
import { UserActionEnum } from '../enums/user-action.enum';
import { AppAbility } from '../types/app-ability';

/**
 * Maps rules used by CASL for authorization to subject abilities used by the app to display permissions
 * @param rules rules to map
 * @returns subject abilities
 */
export function mapRulesToSubjectAbilities(
	rules: RawRuleOf<AppAbility>[],
): SubjectAbilitiesDto[] {
	// Group rules by subject
	const subjectRules = rules.reduce(
		(acc, rule) => {
			const subject = rule.subject as AppSubjectEnum;
			acc[subject] = acc[subject] || [];
			acc[subject].push(rule);
			return acc;
		},
		{} as Record<AppSubjectEnum, RawRuleOf<AppAbility>[]>,
	);

	// Map rules to subject abilities
	const subjectAbilities = Object.entries(subjectRules).map(
		([subject, rules]) => {
			const abilities = rules.map((rule) => ({
				action: rule.action as UserActionEnum,
				allow: !rule.inverted,
			}));
			return {
				subject: subject as AppSubjectEnum,
				abilities,
			};
		},
	);

	return subjectAbilities;
}
